import { render, staticRenderFns } from "./interview-desc.vue?vue&type=template&id=d84fcd0c"
import script from "./interview-desc.vue?vue&type=script&lang=js"
export * from "./interview-desc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports